import { render, staticRenderFns } from "./TitleBar.vue?vue&type=template&id=033c1844"
import script from "./TitleBar.vue?vue&type=script&lang=js"
export * from "./TitleBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports